<template>
  <complaint-list
    mode="assigned"
    api-url="complaints/my/assigned"
    title="Assigned to me"
    subtitle="Complaints you were assigned to investigate. Open one to record your findings."
    icon="UserCheckIcon"
  />
</template>

<script>
import ComplaintList from './ComplaintList.vue'

export default {
  components: { ComplaintList },
}
</script>
